<template>
  <div class="serviceBusyness">
    <busyness-radio :default-value="defaultType" :options="busyOptions" @change="v => activeKey = v" style="margin-left: 10px"></busyness-radio>

    <resource-table
      v-if="itemList"
      :data-source="tableData"
      :item-list="itemList"
    ></resource-table>
  </div>
</template>

<script>
import { getServiceSourceBusyness } from '@/api/service.js'
import {
  getSourceBusynessItemList,
  getSourceBusynessIndicatorList
} from '@/api/source-busyness.js'
import ResourceTable from './modules/ResourceTable.vue'
import BusynessRadio from '@/components/radio/BusynessRadio.vue'

export default {
  name: 'ServiceBusyness',
  components: {
    ResourceTable,
    BusynessRadio
  },
  props: {
    defaultType: {
      type: String
    }
  },
  data () {
    return {
      serviceId: this.$route.params.id,
      activeKey: this.defaultType || 'all',
      dataSource: {},
      allData: [],
      itemList: undefined,
      total: 0,
      busyOptions: [
        {
          label: '正常',
          value: 'normal'
        },
        {
          label: '繁忙',
          value: 'busy'
        },
        {
          label: '空闲',
          value: 'idle'
        }
      ]
    }
  },
  computed: {
    tableData () {
      let arr = []
      if (this.total) {
        if (this.activeKey === 'all') arr = this.allData
        else arr = this.allData.filter(item => item.state === this.activeKey)
      }
      return arr
    }
  },
  created () {
    this.fetchItems()
    this.fetch()
  },
  methods: {
    fetchItems () {
      this.itemList = undefined
      getSourceBusynessIndicatorList().then(res => {
        const data = res.data
        this.itemList = data ? data.data : []
        if (this.itemList.length) {
          getSourceBusynessItemList().then(res1 => {
            const data1 = res1.data
            const arr = data1 ? data1.data : []
            if (arr.length) {
              this.itemList = this.itemList.map(item => {
                const obj = arr.find(i => i.key === item.key)
                return {
                  ...item,
                  name: obj ? obj.name : item.key
                }
              })
            }
          })
        }
      })
    },
    fetch () {
      this.allData = []
      this.total = 0
      getServiceSourceBusyness(this.serviceId).then(res => {
        this.dataSource = res.data
        for (const key in this.dataSource.statistic) {
          if (Object.hasOwnProperty.call(this.dataSource.statistic, key)) {
            const value = this.dataSource.statistic[key]
            this.allData.push(...value.map(item => {
              return {
                ...item,
                state: key
              }
            }))
          }
        }
        this.busyOptions.forEach(item => {
          if (this.dataSource[item.value]) this.total += this.dataSource[item.value]
          item.label = `${item.label} (${this.dataSource[item.value] || 0})`
        })
        this.busyOptions.unshift({
          label: `全部 (${this.total})`,
          value: 'all'
        })
      })
    }
  }
}
</script>

<style lang="less" scoped>
.serviceBusyness {
  background: #fff;
  border-radius: 6px;
  padding: 16px 12px;
}
</style>
